import store from '@/store';
import eventBus from '@/components/shared/eventbus';
import PushNotificationManager from '@/push_notification_manager';

function logTheError(res) {
  console.group('Global error was found');
  console.group('Request:');
  console.log(JSON.stringify(res));
  console.groupEnd('simple');
  console.group('Request data:');
  console.log(JSON.stringify(res.data));
  console.groupEnd('simple');
  console.group('Request response:');
  console.log(JSON.stringify(res.response));
  console.groupEnd('simple');
  console.groupEnd('simple');
}

function handleMultipleClientError(res) {
  store.dispatch('settings/setSelectedLearnedLanguage', res.message);
  location.replace('/');
}

const globalErrorHandler = (res) => {
  let errorFromApi;
  let errorFromApiForCollison;
  let runTimeExecption;
  const invalidationStatus = store.getters['settings/getInvalidationStatus'];
  if (res.data && res.data.response && res.data.response.errors) {
    errorFromApi = res.data.response.errors;
    errorFromApiForCollison = res.data.response.errors;
  }
  if (res.response && res.response.status) {
    runTimeExecption = res.response.status;
  }

  const expression =
    !!(errorFromApiForCollison != undefined &&
    errorFromApiForCollison[0].code === 622);

  if (expression && !location.href.includes('authentication')) {
    handleMultipleClientError(errorFromApiForCollison[0]);
  }

  errorFromApiForCollison = undefined;
  if (errorFromApi || runTimeExecption) {
    logTheError(res);
    let authError;
    if (errorFromApi) {
      authError = errorFromApi.find(x => x.code === 400);
    }
    if (!invalidationStatus) {
      store.dispatch('settings/setInvalidationStatus', true);
      const isDktScreen = location.pathname.split('/')[1].includes('dkt');
      if (!isDktScreen && (authError || runTimeExecption === 400)) {
        const isKretaUser = store.getters['users/isKretaUser'];
        const isKHUser = store.getters['users/isKHUser'];
        if (isKretaUser && (!isKHUser || !location.href.includes('zero-password'))) {
          eventBus.sessionLeft(0);
        } else {
          PushNotificationManager.unsubscribeUser(() => {});
          store.dispatch('users/logout', true).then(() => {
            window.location.href = `/?t=${new Date().getTime()}`;
          });
        }
      }
    }
  }
  // return Promise.reject(error);
};

export default globalErrorHandler;